import { PageHero, Section, Seo, breadcrumb } from "@/components/site/Section";
import { FAQList } from "@/components/site/FAQList";
import { FinalCTA } from "@/components/site/HomeSections";
import { FAQS } from "@/data/faqs";

const CATS = [...new Set(FAQS.map((f) => f.cat))];
const FAQ_LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.filter((f) => !f.a.includes("[")).map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQs() {
  return (
    <>
      <Seo title="Firewood Delivery FAQs" path="/faqs" description="Answers about WeeLogRun firewood and log delivery in Newtownabbey: what's included, delivery areas, pausing, skipping, changing plan and cancelling." jsonLd={[breadcrumb("FAQs", "/faqs"), FAQ_LD]} />
      <PageHero eyebrow="FAQs" title="Questions, answered." intro="Everything you need to know about WeeLogRun. Can't find your answer? Get in touch." />
      <Section className="!pt-14">
        <div className="space-y-16">
          {CATS.map((c) => (
            <div key={c} className="grid gap-6 lg:grid-cols-12">
              <h2 className="font-display text-2xl font-bold text-[#D4A437] lg:col-span-4">{c}</h2>
              <div className="lg:col-span-8">
                <FAQList items={FAQS.filter((f) => f.cat === c)} prefix={`faq-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`} />
              </div>
            </div>
          ))}
        </div>
      </Section>
      <FinalCTA />
    </>
  );
}
